
import JigBlockquote from '@/components/helper/JigBlockquote.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    'jig-blockquote': JigBlockquote,
  },
})

/**
 * JigQuote.vue
 *
 * Composite testimonial component combining an avatar image with JigBlockquote.
 * Renders as a <figure> with an optional avatar and a quoted message.
 * Props:
 * - avatarImgSrc: optional avatar URL
 * - authorName, authorRole, orgName, quote: forwarded to JigBlockquote.
 */
export default class JigQuoteVue extends Vue {
  @Prop({ default: '' })
  avatarImgSrc!: string
  @Prop({ default: '' })
  authorName!: string
  @Prop({ default: '' })
  authorRole!: string
  @Prop({ default: '' })
  orgName!: string
  @Prop({ default: '' })
  quote!: string
}
